import PropTypes from 'prop-types';
import AutoScrollForm from '../AutoScrollForm/AutoScrollForm';
import AddNewFamilyMemberSidebarStyled from './AddNewFamilyMemberSidebarStyled';

const AddNewFamilyMemberSidebarView = ({
  userData,
  primaryButtonClicked,
  setErrorModal,
  getAllProfileData,
  setAddNewUserData,
  setShowAddMemberRightSideBar,
  setCheckSlotAvailability,
  setSuccess,
  docName,
  setDisablePrimaryButtonFromSidebar,
}) => (
  <AddNewFamilyMemberSidebarStyled>
    <AutoScrollForm
      type="addSidebar"
      label="Continue"
      userData={userData}
      setErrorModal={setErrorModal}
      sidebarSubmitClicked={primaryButtonClicked}
      setDisablePrimaryButtonFromSidebar={setDisablePrimaryButtonFromSidebar}
      docName={docName}
      onSuccess={(res) => {
        getAllProfileData();
        setAddNewUserData(res);
        setShowAddMemberRightSideBar(false);
        if (setCheckSlotAvailability) setCheckSlotAvailability(true);
        setSuccess(true);
      }}
    />
  </AddNewFamilyMemberSidebarStyled>
);

AddNewFamilyMemberSidebarView.propTypes = {
  userData: PropTypes.object.isRequired,
  primaryButtonClicked: PropTypes.number.isRequired,
  setErrorModal: PropTypes.func.isRequired,
  getAllProfileData: PropTypes.func.isRequired,
  setAddNewUserData: PropTypes.func.isRequired,
  setShowAddMemberRightSideBar: PropTypes.func.isRequired,
  setCheckSlotAvailability: PropTypes.func.isRequired,
  setSuccess: PropTypes.func.isRequired,
  docName: PropTypes.string.isRequired,
  setDisablePrimaryButtonFromSidebar: PropTypes.func,
};

export default AddNewFamilyMemberSidebarView;
